import React, {useState} from "react";
import "./termsModal.css";
import {instance} from "../../utils/utils";

const TermsModal = ({onClose}) => {
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [sensitiveInfoAccepted, setSensitiveInfoAccepted] = useState(false);
    const [loading, setLoading] = useState(false);

    const isFormValid = termsAccepted && privacyAccepted && sensitiveInfoAccepted;

    const handleSubmit = async () => {
        if (!isFormValid) return;

        setLoading(true);
        try {
            const res = await instance.post("users/terms", {
                terms_and_conditions_accepted: true,
                privacy_policy_accepted: true,
                terms_accepted: true
            });

            if (res.status === 200) {
                localStorage.privacy_policy_accepted = "true";
                localStorage.terms_and_conditions_accepted = "true";

                if (onClose) onClose();
            } else {
                console.error("Error al aceptar términos");
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="modal fade show d-block terms-modal-overlay"
            tabIndex="-1"
            role="dialog"
            style={{backgroundColor: "rgba(0,0,0,0.5)"}}
        >
            <div className="modal-dialog modal-dialog-centered justify-content-center" role="document">
                <div className="modal-content p-4 terms-modal-content">
                    <div className="modal-body text-center terms-modal-body gap-3 d-flex flex-column">
                        <div
                            className="pb-3 terms-modal-header d-flex flex-column justify-content-center align-items-center">
                            <svg
                                width="24"
                                height="28"
                                viewBox="0 0 24 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.0293 0.843728C11.287 0.304695 12.711 0.304695 13.9688 0.843728L22.6553 4.56736C23.268 4.82996 23.6659 5.43199 23.666 6.09861V14.8535C23.666 18.0829 22.1064 21.1141 19.4785 22.9912L13.9365 26.9492C12.7775 27.777 11.2205 27.7771 10.0615 26.9492L4.51953 22.9912C1.89169 21.1141 0.332031 18.0829 0.332031 14.8535V6.09861C0.332123 5.43199 0.730037 4.82996 1.34277 4.56736L10.0293 0.843728ZM17.624 9.21873C17.2198 8.89542 16.6411 8.93717 16.2861 9.29881L16.2178 9.37498L10.25 16.8359L7.70605 14.2929C7.31556 13.9026 6.68248 13.9026 6.29199 14.2929C5.90151 14.6834 5.9016 15.3165 6.29199 15.707L9.23047 18.6455C9.86265 19.2775 10.9035 19.2195 11.4619 18.5215L17.7803 10.625L17.8398 10.542C18.1149 10.1162 18.0283 9.54218 17.624 9.21873Z"
                                    fill="#3177BE"
                                />
                            </svg>

                            <h5 className="mt-3 terms-modal-title">
                                ¡Hola! Has ingresado correctamente a Elevva.
                            </h5>
                        </div>

                        <div className="pb-3 terms-modal-subtitle">
                            <p className="mb-0">
                                Accede a las herramientas necesarias para apoyar la operación
                                diaria del gimnasio: gestiona registros, reservas y acompaña a
                                los usuarios en su día a día.
                            </p>
                        </div>

                        <div className="terms-modal-terms d-flex flex-column gap-1">
                            <p className="text-start terms-modal-info">
                                Declaro que he leído, comprendido y acepto el contenido de la
                                Política de{" "}
                                <a href="https://elevva.com.co/politica-de-privacidad-y-tratamiento-de-datos/"
                                   target="_blank" rel="noopener noreferrer">
                                    Tratamiento de Datos Personales
                                </a>{" "}
                                y el{" "}
                                <a href="https://elevva.com.co/aviso-de-privacidad/" target="_blank"
                                   rel="noopener noreferrer">
                                    Aviso de Privacidad
                                </a>
                                .
                            </p>

                            <div className="terms-modal-checks d-flex flex-column align-items-center">
                                <div className="form-check text-start terms-modal-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="termsCheck"
                                        checked={termsAccepted}
                                        onChange={(e) => setTermsAccepted(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="termsCheck">
                                        He leído y acepto los{" "}
                                        <a
                                            href="https://elevva.com.co/terminos-y-condiciones/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Términos y condiciones
                                        </a>
                                    </label>
                                </div>

                                <div className="form-check text-start mt-2 terms-modal-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="privacyCheck"
                                        checked={privacyAccepted}
                                        onChange={(e) => setPrivacyAccepted(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="privacyCheck">
                                        He leído y acepto las{" "}
                                        <a
                                            href="https://elevva.com.co/politica-de-privacidad-y-tratamiento-de-datos/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Políticas de privacidad
                                        </a>
                                    </label>
                                </div>

                                <div className="form-check text-start mt-2 terms-modal-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="sensitiveCheck"
                                        checked={sensitiveInfoAccepted}
                                        onChange={(e) => setSensitiveInfoAccepted(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="sensitiveCheck">
                                        He sido debidamente informado de que no estoy obligado(a) a
                                        consentir el tratamiento de mis datos sensibles y conociendo
                                        sus fines, autorizo libremente dicho tratamiento.
                                    </label>
                                </div>
                            </div>
                        </div>

                        <button
                            className="btn btn-primary terms-modal-button"
                            onClick={handleSubmit}
                            disabled={!isFormValid || loading}
                        >
                            {loading ? "Enviando..." : "Continuar"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsModal;
